var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87318 0.75C2.65775 0.749834 2.44802 0.819244 2.27522 0.947897C2.10242 1.07655 1.97579 1.25757 1.91418 1.464L0.0311788 7.786C-0.0021485 7.89795 -0.0088691 8.01613 0.0115524 8.13113C0.0319739 8.24613 0.0789731 8.35477 0.148805 8.4484C0.218637 8.54203 0.309371 8.61805 0.413778 8.67041C0.518184 8.72278 0.633378 8.75003 0.750179 8.75H2.33318L1.05318 13.139C0.669179 14.455 2.37718 15.339 3.23118 14.267L9.83818 5.967C9.9261 5.85651 9.98105 5.72344 9.9967 5.5831C10.0123 5.44277 9.98805 5.30086 9.92662 5.17372C9.86519 5.04658 9.76912 4.93936 9.64945 4.8644C9.52978 4.78944 9.39139 4.74979 9.25018 4.75H7.22018L8.21418 2.101C8.27085 1.94982 8.29007 1.78716 8.2702 1.62694C8.25033 1.46671 8.19197 1.31368 8.10008 1.18092C8.0082 1.04816 7.88554 0.939616 7.74259 0.864575C7.59963 0.789534 7.44063 0.750222 7.27918 0.75H2.87318Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilesIcon);
export default __webpack_public_path__ + "static/media/milesIcon.bb9819dbf144f7b5d260960c02b54462.svg";
export { ForwardRef as ReactComponent };